<template>
  <div class="layout-empty">
    <slot />
  </div>
</template>